import intl from "react-intl-universal"
import { useGlobalContext } from 'hooks/useGlobalContext';
import { useZsagContext } from "../context/zsagContext"
import { SaveIcn } from "components/icons/icn-index.icon"
import { SelectBox } from 'components/uikit-adapter/index'
import Input from "components/input";
import BtnMore from 'images/btn-more.svg'
import { autoGenerateSchedulesInsert, retornaObjetoComId } from "../auto-load-optimization.service"
import { errorMessage, validateNewLine } from "../utils/validate"
import { shiftValues } from "../utils/models"
import './styled.css'
import ButtonIcon from "components/button-icon";
import PropTypes from 'prop-types';

const QuantityPalletsInput = ({ id }) => {
  return <Input id={id} htmlType="number" />
};

const NewLine = () => {

  const { showFeedback } = useGlobalContext()
  const {
    volumes,
    setVolumes,
    setLoading,
    filters,
    newLineInProgress,
    setNewLineInProgress,
    setHaveUnsavedChanges,
    materials
  } = useZsagContext()


  const newLine = () => {
    const newVolume = {
      MaterialNumber: () =>
        <div className="autoLoad__selectbox--wrapper">
          <SelectBox
            className="primaryMaterial__selectbox"
            value={""}
            placeholder={intl.get('commons.material')}
            options={materials}
            onChange={(e) => changePrimaryMaterial(e)}
            valueKey="CodigoMaterial"
            labelKey="DescricaoCompleta"
            searchable
            data-testid='primaryMaterial__selectbox'
            dontShowLabel={true}
            width={"250px"}
          />
        </div>
      ,
      QuantityPallets: () => QuantityPalletsInput('new-quantity-pallets'),
      DeliveryDate: () =>
        <Input
          value={""}
          htmlType="date"
          id="new-delivery-date"
          onChange={(e) => changeDeliveryDate(e.target.value)}
          data-testid="inputDeliveryDate"
        />
      ,
      Interval: () =>
        <Input
          value={""}
          mask="time"
          id="new-interval"
          onChange={(e) => changeInterval(e.target.value)}
          data-testid="inputInterval"
        />,
      Shift: () =>
        <div className="autoLoad__selectbox--wrapper">
          <SelectBox
            className="shift__selectbox"
            value={""}
            options={shiftValues}
            onChange={(e) => changeShift(e)}
            valueKey="value"
            labelKey="value"
            searchable
            data-testid='shift__selectbox'
            dontShowLabel={true}
            width={"90px"}
          />
        </div>,
      edit: () => renderSave(),
      Status: { Code: 1, Message: "" },
      Process: "I"
    }

    handleNewLine(newVolume)
    setNewLineInProgress(true)
  }

  const renderSave = () => (
    <StyledSave data-testid='handle-save-new-line' onClick={saveNewLine}> 
      <SaveIcn width="15px" height="15px" /> 
    </StyledSave>
  )

  const saveNewLine = async () => {
    const newLineData = {
      Material: volumes.Schedules[0].MaterialValue,
      QuantityPallets: document.getElementById('new-quantity-pallets').value,
      DeliveryDate: document.getElementById('new-delivery-date').value,
      NewShift: volumes.Schedules[0].ShiftValue,
      Interval: document.getElementById('new-interval').value,
      Process: "I"
    }

    const filtersRequest = {
      Plant: filters.plant.Centro,
      ProductionVersion: filters.productionVersion.productionLine,
      DeliveryDateFrom: filters.date.deliveryDateFrom,
      DeliveryDateTo: filters.date.deliveryDateTo,
      Shift: filters.shift,
      Recalculate: false
    }

    const insertDto = {
      AutoGenerateSchedulesFilterDto: filtersRequest,
      NewLine: newLineData
    }


    if (!validateNewLine(newLineData, processError)) {
      setLoading(true)
      await autoGenerateSchedulesInsert(insertDto)
        .then((response) => {
          processNewData(response)
          setHaveUnsavedChanges(true)
        })
        .catch((e) => processError(e));
      setLoading(false)
    }
  }

  const changePrimaryMaterial = (value) => {
    const _volumes = volumes
    _volumes.Schedules[0].MaterialValue = value.CodigoMaterial
    _volumes.Schedules[0].MaterialNumber = () =>
      <div>
        <SelectBox
          className="primaryMaterial__selectbox"
          placeholder={intl.get('commons.material')}
          value={value}
          options={materials}
          onChange={(e) => changePrimaryMaterial(e)}
          valueKey="CodigoMaterial"
          labelKey="DescricaoCompleta"
          searchable
          data-testid='primaryMaterial__selectbox'
          dontShowLabel={true}
          width={"250px"}
        />
      </div>

    setVolumes({ ..._volumes })
  }

  const changeShift = (value) => {
    const _volumes = volumes
    _volumes.Schedules[0].ShiftValue = value.value
    _volumes.Schedules[0].Shift = () =>
      <div className="autoLoad__selectbox--wrapper">
        <SelectBox
          className="shift__selectbox"
          value={value}
          options={shiftValues}
          onChange={(e) => changeShift(e)}
          valueKey="value"
          labelKey="value"
          searchable
          data-testid='shift__selectbox'
          dontShowLabel={true}
          width={"90px"}
        />
      </div>
    setVolumes({ ..._volumes })
  }

  const changeDeliveryDate = (value) => {
    const _volumes = volumes;
    _volumes.Schedules[0].DeliveryDate = () =>
      <Input
        required
        value={value}
        id="new-delivery-date"
        onChange={e => changeDeliveryDate(e.target.value)}
        data-testid='input'
        htmlType="date"
        className="input"
      />

    setVolumes({ ..._volumes })
  }

  const changeInterval = (value) => {
    const _volumes = volumes;
    _volumes.Schedules[0].Interval = () =>
      <Input
        required
        id="new-interval"
        value={value}
        onChange={e => changeInterval(e.target.value)}
        data-testid='input'
        mask="time"
      />

    setVolumes({ ..._volumes })
  }

  const processNewData = (line) => {
    const schedules = [...volumes.Schedules];
    schedules[0] = line;

    const _volumes = {
      ...volumes,
      Schedules: schedules.map((value, index) => retornaObjetoComId(value, index))
    }

    setVolumes({ ..._volumes })
    showFeedback(intl.get("feedbacks.savedRegister"))
    setNewLineInProgress(false)
  }

  const handleNewLine = (newVolume) => {
    const _volumes = volumes;

    _volumes.Schedules = [
      newVolume,
      ..._volumes.Schedules
    ]
    setVolumes({ ..._volumes })
  }

  const processError = e => {
    showFeedback(errorMessage(e));
  }

  return (
    <div className='btn-wrapper' data-testid='btn-more-new-line'>
      <ButtonIcon
        buttonType="secondary"
        buttonIcon={BtnMore}
        className='btn-action'
        onClick={newLine}
        disabled={newLineInProgress}
      />
    </div>
  )
}

QuantityPalletsInput.propTypes = {
  id: PropTypes.string.isRequired
};

export default NewLine
